import { Badge, Flex } from "@mantine/core";
import { AsurionWorkspaceLogo } from "@/common-ui";
import { usePartnerConfig } from "@/partner/usePartnerConfig";
import { useAgentStore, useSessionId } from "@/sdk";
import { useFeatureFlag } from "@/shared-utils/hooks/useFeatureFlag";
import { HeaderControls } from "./HeaderControls";
import { SessionIdCopyButton } from "./SessionIdCopyButton";
import classes from "./WorkspaceHeader.module.css";

export function WorkspaceHeader() {
    const sessionId = useSessionId();
    const currentActivity = useAgentStore((state) => state.activity);
    const trainingBadge = "Training Mode";
    const { data: isEnrolledInExpertUniversity } = useFeatureFlag("isEnrolledInExpertUniversity", undefined);
    const { trainingAgentActivity } = usePartnerConfig();
    return (
        <Flex p="xxs" align="center" className={classes.headerContainer}>
            <Flex>
                <Flex className={classes.logo}>
                    <AsurionWorkspaceLogo />
                </Flex>
                {trainingAgentActivity && currentActivity === trainingAgentActivity && isEnrolledInExpertUniversity && (
                    <Badge fz="xs" ml="sm" mt="0.3rem" className={classes.trainingHeaderContainer}>
                        {trainingBadge}
                    </Badge>
                )}
                {sessionId && <SessionIdCopyButton key={sessionId} sessionId={sessionId} />}
            </Flex>
            <HeaderControls />
        </Flex>
    );
}
